const requireFieldList = require.context('.', true, /\.vue$/)
const componentModules = {}

requireFieldList.keys().forEach((fileName) => {
  const path = fileName.replace(/(\.\/|\.vue)/g, '')
  componentModules[path] = requireFieldList(fileName).default
})
export default componentModules
